import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import ButtonVerificationCode from './ButtonVerificationCode.vue';
import Modal from '@/components/Modal/index.vue';
import { smsCodeUsingGET, applyUsingPOST } from '@/service/apiService';
import { actId } from '@/utils/const'; // 表单校验规则

var rules = {
  noEmpty: function noEmpty(val) {
    return !!val.trim();
  },
  phoneNum: function phoneNum(val) {
    return /^\d{11}$/.test(val);
  },
  validateCode: function validateCode(val) {
    return /^\d{6}$/.test(val);
  },
  email: function email(val) {
    return /^([A-Za-z0-9_\-.\u4e00-\u9fa5])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,8})$/.test(val);
  },
  idcard: function idcard(val) {
    return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(val);
  }
};
var forms = {
  developerName: {
    value: '',
    valid: false,
    tips: '',
    rules: [[rules.noEmpty, '姓名不能为空']]
  },
  company: {
    value: '',
    valid: false,
    tips: '',
    rules: [[rules.noEmpty, '公司不能为空']]
  },
  office: {
    value: '',
    valid: false,
    tips: '',
    rules: [[rules.noEmpty, '职位不能为空']]
  },
  email: {
    value: '',
    valid: false,
    tips: '',
    rules: [[rules.email, '请输入正确的邮箱']]
  },
  phone: {
    value: '',
    valid: false,
    tips: '',
    rules: [[rules.phoneNum, '请输入正确的联系电话']]
  },
  validMessage: {
    value: '',
    valid: false,
    tips: '',
    rules: [[rules.validateCode, '请输入正确的验证码']]
  },
  idcard: {
    value: '',
    valid: false,
    tips: '',
    rules: [[rules.idcard, '请输入正确的身份证号码']]
  },
  from: {
    value: '',
    valid: false,
    tips: '',
    rules: [[rules.noEmpty, '地区不可以为空']]
  },
  subConf: {
    value: '',
    valid: false,
    tips: '',
    rules: [[rules.noEmpty, '请选择您参与的分会场']]
  }
};

var Index = /*#__PURE__*/function (_Vue) {
  _inherits(Index, _Vue);

  var _super = _createSuper(Index);

  function Index() {
    var _this;

    _classCallCheck(this, Index);

    _this = _super.apply(this, arguments);
    _this.forms = forms;
    _this.mainConfChecked = false;
    _this.subConfs = ['应用服务分会场', '游戏生态分会场', '商业合作分会场', '技术开放分会场', 'IoT开放生态分会场'];
    _this.showSubmitModal = false;
    _this.showSubmitResultModal = false;
    _this.submitIng = false;
    return _this;
  }

  _createClass(Index, [{
    key: "created",
    value: function created() {// 测试用
      // if (process.env.NODE_ENV === 'development') {
      //     this.forms.developerName.value = '佚名';
      //     this.forms.company.value = 'vivo';
      //     this.forms.office.value = '产品经理';
      //     this.forms.email.value = '123@vivo.com';
      //     this.forms.phone.value = '12344445555';
      //     this.forms.validMessage.value = '123456';
      //     this.forms.idcard.value = '421953199911101722';
      //     this.forms.from.value = '湖北';
      // }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      // 表单未提交，退出网页时，给出提示
      var unsubmitFormCheckHandler = function unsubmitFormCheckHandler(e) {
        var hasInput = false;
        Object.keys(_this2.forms).forEach(function (key) {
          if (_this2.forms[key].value.trim()) {
            hasInput = true;
          }
        });

        if (hasInput) {
          var tips = '你的信息未填写完成确认退出吗?';
          e.preventDefault();
          e.returnValue = tips;
          return tips;
        }
      };

      window.addEventListener('beforeunload', unsubmitFormCheckHandler);
      this.$on('hook:beforeDestroy', function () {
        window.removeEventListener('beforeunload', unsubmitFormCheckHandler);
      });
    }
  }, {
    key: "validate",
    value: function validate(prop) {
      var _this$forms$prop = this.forms[prop],
          value = _this$forms$prop.value,
          rules = _this$forms$prop.rules;
      var result = true;
      var tips = '';

      for (var i = 0; i < rules.length; i++) {
        var _rules$i = _slicedToArray(rules[i], 2),
            rule = _rules$i[0],
            errorMsg = _rules$i[1];

        if (!rule(value)) {
          result = false;
          tips = errorMsg;
          break;
        }
      }

      ;
      this.forms[prop].tips = tips;
      this.forms[prop].valid = result;
      return result;
    }
  }, {
    key: "toggleMainConfRodio",
    value: function toggleMainConfRodio() {
      this.mainConfChecked = !this.mainConfChecked;
    }
  }, {
    key: "toggleSubConfRadio",
    value: function toggleSubConfRadio(index) {
      this.forms.subConf.value = "".concat(index + 1);
      this.forms.subConf.tips = '';
    }
  }, {
    key: "sendVerificationCodeHandler",
    value: function () {
      var _sendVerificationCodeHandler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(next) {
        var _this$forms$phone, phoneNum, valid, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.isEnd) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this$forms$phone = this.forms.phone, phoneNum = _this$forms$phone.value, valid = _this$forms$phone.valid;

                if (!valid) {
                  _context.next = 17;
                  break;
                }

                _context.prev = 4;
                _context.next = 7;
                return smsCodeUsingGET({
                  actId: actId,
                  phone: phoneNum
                });

              case 7:
                data = _context.sent;

                if (data.code === 0) {
                  next();
                } else {
                  this.forms.phone.tips = data.msg;
                }

                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](4);
                console.error(_context.t0);
                this.forms.phone.tips = '获取验证码失败，请重试！';

              case 15:
                _context.next = 18;
                break;

              case 17:
                // alert('请填写电话号码！');
                this.$refs.phoneInput.focus();

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 11]]);
      }));

      function sendVerificationCodeHandler(_x) {
        return _sendVerificationCodeHandler.apply(this, arguments);
      }

      return sendVerificationCodeHandler;
    }()
  }, {
    key: "confirmHandler",
    value: function confirmHandler() {
      var isAllValid = this.isAllValid();
      if (!isAllValid) return undefined;
      this.showSubmitModal = true;
    }
  }, {
    key: "submitHandler",
    value: function () {
      var _submitHandler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.submitIng) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                this.submitIng = true;
                _context2.prev = 3;
                _context2.next = 6;
                return applyUsingPOST(this.formData);

              case 6:
                data = _context2.sent;
                this.showSubmitModal = false;
                this.submitIng = false;

                if (data.code === 0) {
                  this.showSubmitResultModal = true;
                  this.resetForm(); // 报名成功时验证码数秒取消
                  // @ts-ignore

                  this.$refs.buttonVerification.reset();
                } else if (data.code === 703) {
                  // 短信验证码错误
                  this.forms.validMessage.value = ''; // 清空

                  alert(data.msg);
                } else {
                  alert(data.msg);
                }

                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](3);
                this.submitIng = false;
                alert('提交失败，请稍后再试！');

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 12]]);
      }));

      function submitHandler() {
        return _submitHandler.apply(this, arguments);
      }

      return submitHandler;
    }()
  }, {
    key: "isAllValid",
    value: function isAllValid() {
      var _this3 = this;

      var res = true;
      Object.keys(this.forms).forEach(function (key) {
        // console.log(`${key} --- ${this.validate(key)}`);
        if (!_this3.validate(key)) {
          res = false;
        }
      });
      return res;
    }
  }, {
    key: "resetForm",
    value: function resetForm() {
      var _this4 = this;

      this.mainConfChecked = false;
      Object.keys(this.forms).forEach(function (key) {
        _this4.forms[key].value = '';
        _this4.forms[key].valid = false;
      });
    }
  }, {
    key: "isNotStart",
    get: function get() {
      return this.homeData.now < this.homeData.applyStartTime;
    }
  }, {
    key: "inStart",
    get: function get() {
      return this.homeData.now >= this.homeData.applyStartTime && this.homeData.now < this.homeData.applyEndTime;
    }
  }, {
    key: "isEnd",
    get: function get() {
      return this.homeData.now >= this.homeData.applyEndTime;
    }
  }, {
    key: "formData",
    get: function get() {
      return {
        actId: actId,
        developerName: this.forms.developerName.value.trim(),
        company: this.forms.company.value.trim(),
        office: this.forms.office.value.trim(),
        phone: this.forms.phone.value,
        stage: "".concat(this.mainConfChecked ? '1' : '').concat(this.forms.subConf.value),
        email: this.forms.email.value,
        validMessage: this.forms.validMessage.value,
        idCardNo: this.forms.idcard.value,
        area: this.forms.from.value
      };
    }
  }, {
    key: "confTXT",
    get: function get() {
      if (this.formData.stage && this.formData.stage.length === 1) {
        return "".concat(this.subConfs[+this.formData.stage - 1]);
      } else if (this.formData.stage && this.formData.stage.length === 2) {
        return "\u4E3B\u4F1A\u573A\u3001".concat(this.subConfs[+this.formData.stage[1] - 1]);
      }
    }
  }]);

  return Index;
}(Vue);

__decorate([Prop({
  required: true,
  default: {}
})], Index.prototype, "homeData", void 0);

Index = __decorate([Component({
  name: 'ViewJoin',
  components: {
    ButtonVerificationCode: ButtonVerificationCode,
    Modal: Modal
  }
})], Index);
export default Index;